export default __webpack_public_path__ + "static/media/footer.2004b791.png";